import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import ReactMarkdown from "react-markdown"

const BlogPostTemplate = ({ location, data }) => {
  const post = data.markdownRemark

  return (
    <Layout location={location}>
      <Seo title={post.frontmatter.title} description={post.excerpt} />
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <div className="w-full bg-white shadow">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-bold">{post.frontmatter.title}</h1>
            {post.frontmatter.category && (
              <p className="text-lg font-bold">
                Category: {post.frontmatter.category}
              </p>
            )}
          </div>
        </div>
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <ReactMarkdown
            components={{
              h1: ({ node, ...props }) => (
                <h1 className="text-5xl my-4" {...props} />
              ),
              h2: ({ node, ...props }) => (
                <h2 className="text-3xl my-4" {...props} />
              ),
              p: ({ node, ...props }) => (
                <p className="prose mb-2" {...props} />
              ),
              a: ({ node, ...props }) => (
                <a
                  className="prose underline text-blue-600"
                  target="_blank"
                  {...props}
                />
              ),
              img: ({ node, ...props }) => {
                return (
                  <img
                    className="prose underline text-blue-600"
                    {...props}
                    src={props.src.replace("/static", "")}
                  />
                )
              },
              ol: ({ node, ...props }) => {
                return <ol className="list-decimal" {...props} />
              },
              ul: ({ node, ...props }) => {
                return <ul className="list-disc" {...props} />
              },
            }}
            children={post.rawMarkdownBody}
          />
        </div>
      </article>
    </Layout>
  )
}

export const query = graphql`
  query BlogPostBySlug($id: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      rawMarkdownBody
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        category
      }
    }
  }
`

export default BlogPostTemplate
